<script setup>
/* eslint-disable */
import { onMounted, onUnmounted, watch, ref } from 'vue';
import { useSocketStore } from '@/stores/socket';
import { usePreSportsStore } from '@/stores/pre_sports';
import { useLiveSportsStore } from '@/stores/live_sports';
import { useLiveSportOverview } from '@/stores/live_sport_overview';
import { useMarketsStore } from '@/stores/markets';
import { useGeneralStore } from '@/stores/general';
import { useRouter, useRoute } from 'vue-router';
import { useSportPopularStore } from '@/stores/sport_popular';

import EsportFeaturedFixtures from '@/components/esports/EsportFeaturedFixtures.vue';
import LiveOverview from '@/components/esports/highlights/LiveOverview.vue';
import AllUpcomingOverview from '@/components/esports/highlights/AllUpcomingOverview.vue';
import PopularOverview from '@/components/esports/highlights/PopularOverview.vue';
import { useI18n } from 'vue-i18n';

const socketStore = useSocketStore();
const preSportsStore = usePreSportsStore();
const liveSportsStore = useLiveSportsStore();
const marketsStore = useMarketsStore();
const liveSportOverviewStore = useLiveSportOverview();
const generalStore = useGeneralStore();
const sportPopularStore = useSportPopularStore();

const router = useRouter();
const route = useRoute();

const { t } = useI18n();

const active_tab = ref('upcoming');

const show_scroll_to_top_button = ref(false);

const show_primary_overview_market = ref(false);
const show_secondary_overview_market = ref(false);

const primary_overview_market = ref(null);
const secondary_overview_market = ref(null);

const changeTab = (tab) => {
	active_tab.value = tab;
}

const selectPrimaryOverviewMarket = (overview_market) => {
	primary_overview_market.value = overview_market;
	show_primary_overview_market.value = false;
}

const selectSecondaryOverviewMarket = (overview_market) => {
	secondary_overview_market.value = overview_market;
	show_secondary_overview_market.value = false;
}

const closePrimaryOverviewMarketSelector = () => {
	show_primary_overview_market.value = false;
}

const closeSecondaryOverviewMarketSelector = () => {
	show_secondary_overview_market.value = false;
}

const handleScroll = () => {
	const scrollTop = window.scrollY;
	show_scroll_to_top_button.value = scrollTop > 100;
};
const scrollToTop = () => {
	const container = document.querySelector('.live-tab-info');
	window.scrollTo({ top: 0 });
};
const upcomingData = ref([]);
onMounted(async () => {
  const allRes = await global.axios.get(process.env.VUE_APP_SPORTSBOOK_API_URL + '/esports/upcoming/all', { withCredentials: false });
  if (allRes?.data) {
    upcomingData.value = allRes.data; // Store all upcoming data separately


    // Fetch markets based on selected sport id
	let sport_keys = Object.keys(allRes.data);

    let selected_esport = allRes.data[sport_keys[0]]; // Example to pick a sport, adapt as needed
	// alert(JSON.stringify(selected_esport[0].sport_id));
	let sport_overview_markets = marketsStore.sportOverviewMarkets(selected_esport[0].sport_id);

	if (Array.isArray(sport_overview_markets) && sport_overview_markets.length > 1) {
		primary_overview_market.value = sport_overview_markets[0];
		secondary_overview_market.value = sport_overview_markets[1];
	} else if (Array.isArray(sport_overview_markets) && sport_overview_markets.length > 0) {
		primary_overview_market.value = sport_overview_markets[0];
		secondary_overview_market.value = sport_overview_markets[0];
	}

    // You can emit socket events here based on the selected sport id if necessary
    socketStore.join('sportHighlights', selected_esport[0].sport_id);
    socketStore.join('liveSportOverview', selected_esport[0].sport_id);
  }
});

onUnmounted( () => {
	socketStore.leave('sportHighlights', preSportsStore.selectedEsportId);
	socketStore.leave('liveSportOverview');
	liveSportOverviewStore.emptyLiveSportsOverview();
})

watch(() => preSportsStore.esports, (newSports, oldSports) => {
	if (oldSports.length == 0 && newSports.length > 0) {
		let selected_esport = _.find(preSportsStore.esports, {'id': Number(router.currentRoute.value.params.sport_id) });
		if (!selected_esport) return;
		document.title = generalStore.getGeneral.site_name + ' - ' + selected_esport.name + ' ' + t('general.highlights');
	}
})

watch(route, (to, from) => {
	if (!to.params.hasOwnProperty('sport_id') || to.params.sport_id == '') return;

	socketStore.join('sportHighlights', to.params.sport_id);
	socketStore.join('liveSportOverview', to.params.sport_id);

	let sport_overview_markets = marketsStore.sportOverviewMarkets(router.currentRoute.value.params.sport_id);
	if (sport_overview_markets.length > 1) {
		primary_overview_market.value = sport_overview_markets[0];

		secondary_overview_market.value = sport_overview_markets[1]
	} else {
		primary_overview_market.value = sport_overview_markets[0];
		secondary_overview_market.value = sport_overview_markets[0]
	}

	let selected_esport = _.find(preSportsStore.esports, {'id': Number(router.currentRoute.value.params.sport_id) });
	document.title = generalStore.getGeneral.site_name + ' - ' + selected_esport.name + ' ' + t('general.highlights');

});

</script>

<template>

	<div class="live-bet-dashboard round-games-main all-esports-main">
		<div class="live-tab-info" id="tabs">
			<AllUpcomingOverview  :upcomingData="upcomingData" :primary_overview_market="primary_overview_market" :secondary_overview_market="secondary_overview_market"/>
		</div>
	</div>
	<button @click="scrollToTop" type="button" class="btn scroll-to-top" id="btn-back-to-top" v-show="show_scroll_to_top_button">
		<i class="fas fa-arrow-up"></i>
	</button>
</template>
<style scoped>
@media screen and (min-width: 768px) and (max-width: 991px) {
	.live-bet-dashboard .live-tab-info {
		max-height: unset;
	}
}
@media screen and (min-width: 992px) and (max-width: 3000px) {
	button#btn-back-to-top {
		display:none;
	}
}
@media screen and (min-width: 320px) and (max-width: 991px) {
	button#btn-back-to-top {
		bottom: 95px;
		left: 20px;
	}
}
@media screen and (min-width: 320px) and (max-width: 767px) {
	svg.svg-inline--fa.fa-arrow-up.fa-w-14 {
		margin-bottom: 7px!important;
	}
	button#btn-back-to-top {
		width: 30px!important;
		height: 30px!important;
		font-size: 14px!important;
	}
}
button#btn-back-to-top {
	background: var(--primary);
	color: var(--buttons-text-color);
	width: 38px;
	height: 38px;
	border: none;
	border-radius: 50%;
	position: fixed;
	z-index: 99;
	box-shadow: 0 2px 4px var(--list-gray);
	font-size: 16px;
	cursor: pointer;
}
html[dir="rtl"] button#btn-back-to-top {
	left: unset;
	right:20px;
}
@media screen and (min-width: 320px) and (max-width: 991px) {
	button#btn-back-to-top {
		left: 10px;
	}
}
@media screen and (min-width: 320px) and (max-width: 767px) {
	html[dir="rtl"] button#btn-back-to-top {
		left: unset;
		right:10px;
	}
}
.live-bet-dashboard.round-games-main .bet-dashboard-top:after {
	width: 100% !important;
}
@media screen and (min-width: 768px) {
	.tab-pills {
		padding-bottom: 12px;
	}
}
@media screen and (min-width: 320px) and (max-width: 767px) {
	.dropdown-option-top-2 {
		display: none;
	}
}
@media screen and (min-width: 320px) and (max-width: 323px) {
	.last-btn {
		margin-top: 5px;
	}
}

html[dir="rtl"] .live-bet-dashboard .bet-dashboard-top:after {
	right: unset;
	left: 0px;
}

</style>